import { InspModelItem, RuleItem } from "@types";
import { useEffect, useState } from "react";
import { RuleTable } from "../../components/new/RuleTable";
import { ModelCard } from "../../components/new/ModelCard";
import { getSimpleInspModelList } from "../../services/modelService";
import { getInspRules } from "../../services/inspectService";
import { Plus } from "lucide-react";
import { Box } from "@mui/material";
import PageShell from "../../components/new/PageShell";

type TabType = "model" | "rule";

export default function InspectionPage() {
  const [tab, setTab] = useState<TabType>("model");
  const [modelList, setModelList] = useState<InspModelItem[]>([]);
  const [ruleList, setRuleList] = useState<RuleItem[]>([]);

  const fetchModelData = async () => {
    const modelData = await getSimpleInspModelList();
    setModelList(modelData);
  };

  const fetchRuleData = async () => {
    const ruleData = await getInspRules();
    setRuleList(ruleData);
  };

  useEffect(() => {
    fetchModelData();
    fetchRuleData();
  }, []);

  return (
    <PageShell title="검사관리">
      {/* Tabs */}
      <div className="flex border-b border-gray-200 mb-6">
        <button
          onClick={() => setTab("model")}
          className={`px-4 py-2 font-medium ${
            tab === "model" ? "border-b-2 border-blue-600 text-blue-600" : "text-gray-500"
          }`}
        >
          검사모델
        </button>

        <button
          onClick={() => setTab("rule")}
          className={`px-4 py-2 font-medium ${
            tab === "rule" ? "border-b-2 border-blue-600 text-blue-600" : "text-gray-500"
          }`}
        >
          검사규칙
        </button>
      </div>

      {/* Content */}
      <div className="flex-1">
        {tab === "model" && (
          <Box sx={{ width: "100%" }}>
            {/* <div className="w-full flex justify-end mb-2">
                <button className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors">
                  <Plus />
                  <span>새 모델</span>
                </button>
              </div> */}

            <ModelCard ruleList={ruleList} setRuleList={setRuleList} onModelsChanged={fetchModelData} />
          </Box>
        )}

        {tab === "rule" && <RuleTable modelList={modelList} ruleList={ruleList} setRuleList={setRuleList} />}
      </div>
    </PageShell>
  );
}
